import { render } from "./Flussi.vue?vue&type=template&id=bd441748"
import script from "./Flussi.vue?vue&type=script&lang=js"
export * from "./Flussi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\DEV\\SHIRE\\nic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__